import '../../sass/blocks/checkout.scss';

import cachios from 'cachios';
import { hideExpandable } from '../common/expandable';
import { updateSiteHeaderBasketNumber } from '../layouts/site-header';

(() => {
    const $checkouts = document.querySelectorAll('.checkout');

    if (!$checkouts) return;

    $checkouts.forEach($checkout => {
        const $productCartItems = $checkout.querySelectorAll('.product-cart-item');
        const $checkoutBasketNumber = $checkout.querySelector('.checkout-basket__number');
        const $checkoutErrors = $checkout.querySelector('.checkout-errors');

        const $checkoutMainNext = $checkout.querySelector('.checkout-main__next');

        const removeProductCartItem = $productCartItem => {
            if (!$productCartItem || $productCartItem.classList.contains('product-cart-item--hide')) return;

            $productCartItem.style.height = `${$productCartItem.scrollHeight}px`;

            window.requestAnimationFrame(() => {
                $productCartItem.classList.add('product-cart-item--hide');
                $productCartItem.style.height = '';

                setTimeout(() => {
                    if ($productCartItem) {
                        $productCartItem.remove();
                    }
                }, 1000);
            });
        };

        const initProductCartItems = () => {
            if (!$productCartItems) return;

            $productCartItems.forEach($productCartItem => {
                const $removeItemForm = $productCartItem.querySelector('.product-cart-item__remove-item');
                const $removeItemFormNonce = $productCartItem.querySelector('[name=armourcoat_theme_ajax_remove_cart_item_wpnonce]');
                const $removeItemFormType = $productCartItem.querySelector('[name=type]');
                const $removeItemFormProductRangeId = $productCartItem.querySelector('[name=product_range_id]');
                const $removeItemFormProductId = $productCartItem.querySelector('[name=product_id]');
                const $removeItemFormFinishId = $productCartItem.querySelector('[name=finish_id]');
                const $removeItemFormColourId = $productCartItem.querySelector('[name=colour_id]');

                if ($removeItemForm) {
                    $removeItemForm.addEventListener('submit', e => {
                        e.preventDefault();
        
                        $productCartItem.classList.add('product-cart-item--loading');

                        cachios.get(GLOBALS.AJAX_URL, {
                            params: {
                                action: 'armourcoat_theme_ajax_remove_cart_item', 
                                nonce: $removeItemFormNonce?.value,
                                type: $removeItemFormType?.value,
                                product_range_id: $removeItemFormProductRangeId?.value,
                                product_id: $removeItemFormProductId?.value,
                                finish_id: $removeItemFormFinishId?.value,
                                colour_id: $removeItemFormColourId?.value,
                                cachbuster: Date.now(),
                            }
                        }).then(response => {
                            if (response?.data?.success) {
                                if (!isNaN(response?.data?.cartItemCount) && response?.data?.cartPage && response.data.cartItemCount === 0) {
                                    window.location.href = response.data.cartPage;
                                } else {
                                    removeProductCartItem($productCartItem);

                                    if (response?.data?.basketQuantityTextShort && $checkoutBasketNumber) {
                                        $checkoutBasketNumber.innerHTML = response?.data?.basketQuantityTextShort;
                                    }

                                    if (!response?.data?.cartItemCount || !response?.data?.cartMaximum || response?.data?.cartItemCount <= response?.data?.cartMaximum) {
                                        hideExpandable($checkoutErrors);
                                        $checkoutMainNext.classList.remove('checkout-main__next--disabled');
                                    }

                                    if (response?.data?.cartItemCount) {
                                        updateSiteHeaderBasketNumber(response.data.cartItemCount);
                                    }
                                }
                            }
                        }).catch(thrown => {
                            console.log(thrown);
                        }).finally(() => {
                        });
                    });
                }
            });
        };

        initProductCartItems();
    });
})();
